import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { documentRevisionStatusMap } from '@constants/table';
import { RevisionKind } from '@models/revision/revision-kind';
import { DocumentRevisionStatus } from '@models/shared/document-revision-status';

@Component({
    imports: [MatIconModule],
    template: `@if (!params.data.isHeader) {
        <div class="flex items-center">
            <mat-icon [svgIcon]="icon" class="mr-1" />
            <span
                [class.text-semi]="isFinalVersion"
                [class.color-yellow-green8]="isFinalVersion">
                {{ label }}
            </span>
        </div>
    }`,
})
export class StatusCellComponent implements ICellRendererAngularComp {
    public params!: ICellRendererParams;
    icon: string = '';
    label: string = '';

    get isFinalVersion() {
        return this.params?.data.kind === RevisionKind.FINAL_VERSION;
    }

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.setStatusInfo();
    }

    refresh() {
        return false;
    }

    private setStatusInfo() {
        if (!this.params.data.isHeader) {
            try {
                const revisionProperty =
                    documentRevisionStatusMap[
                        this.params.data.relationKind as DocumentRevisionStatus
                    ];
                if (revisionProperty) {
                    const { icon, label } = revisionProperty;
                    this.icon = icon;
                    this.label = label;
                }
            } catch {
                this.icon = '';
                this.label = '';
            }
        }
    }
}
